export default __webpack_public_path__ + "static/media/arc11.973609fe.webp";